import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonIcon(props: IconProps) {
    return <Icon {...props} iconKey={"person"}/>
}
